import { render, staticRenderFns } from "./DinnerMenu.vue?vue&type=template&id=7200d452"
import script from "./DinnerMenu.vue?vue&type=script&lang=js"
export * from "./DinnerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports